<template>
  <drawer-head subTitle="地图设置"></drawer-head>
</template>
<script>
import DrawerHead from "@components/frontline/DrawerHead";
export default {
  name: "Setting4Map",
  components: {
    DrawerHead,
  },
};
</script>
